import { styled } from '@mui/material/styles';

export const StyledLocationList = styled('div')(
  ({ theme, $showDailyFilters, $allItemsDisplayed }) => `
    display: flex;
    flex-flow: column nowrap;
    max-height: 80vh;
    overflow: auto;
    gap: ${theme.DS_spacing(['md'])};
    padding-bottom: ${$allItemsDisplayed ? `600px` : `24px`};
    background-color: white;
    > div:first-of-type {
     margin-top: ${$showDailyFilters ? `${theme.DS_spacing(['lg'])}` : `inherit`};
  `,
);
